// UPDATED FILE: pages/RouterTest.js (renamed from Test.js)
// This is a simple router test page to verify React Router navigation.
// It includes buttons to navigate to other routes (some protected, so login first if needed).
// Displays current path and some test content to confirm rendering.
// Title updated to "Router Test".

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function RouterTest() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Router Test - React Router Function Test</h1>
      <p>Current Path: {location.pathname}</p>
      <p>This page confirms routing works. You can use the buttons below to test navigation.</p>
      
      <div style={{ margin: '20px 0' }}>
        <h2>Test Navigation Buttons:</h2>
        <button onClick={() => handleNavigate('/')} style={{ margin: '5px', padding: '10px' }}>
          Go to Home (Protected - Login required)
        </button>
        <br />
        <button onClick={() => handleNavigate('/details')} style={{ margin: '5px', padding: '10px' }}>
          Go to Details (Protected)
        </button>
        <br />
        <button onClick={() => handleNavigate('/enquiry')} style={{ margin: '5px', padding: '10px' }}>
          Go to Enquiry (Protected)
        </button>
        <br />
        <button onClick={() => handleNavigate('/thankyou')} style={{ margin: '5px', padding: '10px' }}>
          Go to Thank You (Public)
        </button>
        <br />
        <button onClick={() => handleNavigate('/logout')} style={{ margin: '5px', padding: '10px' }}>
          Go to Logout
        </button>
        <br />
        <button onClick={() => handleNavigate('/test')} style={{ margin: '5px', padding: '10px' }}>
          Stay on Router Test
        </button>
      </div>

      <div style={{ margin: '20px 0', border: '1px solid #ccc', padding: '10px' }}>
        <h3>Test React Rendering:</h3>
        <p>Static Text: This is rendered by React.</p>
        <ul>
          <li>Item 1: Routing test passed if you see this.</li>
          <li>Item 2: Navigate away and back to confirm state reset.</li>
          <li>Item 3: Check browser console for any errors (F12).</li>
        </ul>
      </div>

      <button 
        onClick={() => alert('Router Test Alert: React function triggered!')} 
        style={{ margin: '5px', padding: '10px', backgroundColor: 'green', color: 'white' }}
      >
        Test Simple React Function (Alert)
      </button>
    </div>
  );
}

export default RouterTest;